import styled from 'styled-components';
import { useQuery, gql } from '@apollo/client';
import { SwipeableList } from '@sandstreamdev/react-swipeable-list';
import '@sandstreamdev/react-swipeable-list/dist/styles.css';

import Item from './Item';
import { useShoppingCart } from 'Components/ShoppingCartUniverse';
import { GetRemovedVariations, GetRemovedVariationsVariables } from './__queries__';
import useI18n from 'i18n';

export const REMOVED_VARIATIONS_QUERY = gql`
  query GetRemovedVariations($removedVariationIds: [ID!]) {
    allVariations(filter: { id_in: $removedVariationIds }) {
      id
      name
    }
  }
`;

const Wrapper = styled.div`
  overflow: hidden;
  height: auto;
`;

const CartItems = () => {
  const shoppingCart = useShoppingCart();
  const { i18n } = useI18n();
  const removedVariationIds = shoppingCart.items.flatMap((item) => item.removedVariations);
  const { data } = useQuery<GetRemovedVariations, GetRemovedVariationsVariables>(
    REMOVED_VARIATIONS_QUERY,
    {
      variables: {
        removedVariationIds,
      },
    },
  );
  const removedVariationsList = data?.allVariations;
  const threshold = 0.3;

  return (
    <Wrapper>
      <SwipeableList threshold={threshold}>
        {shoppingCart.items.map((item) => {
          return (
            <Item
              key={item.id}
              title={item.title}
              offerTitle={item.offerTitle ? i18n(item.offerTitle) : shoppingCart.offer?.title}
              id={item.itemId}
              variations={item.variations}
              amount={item.amount}
              discount={item.discount}
              removedVariations={
                removedVariationsList
                  ?.filter((rv) => item.removedVariations.includes(rv.id))
                  .map((rv) => rv.name) ?? []
              }
              cartItemId={item.id}
              threshold={threshold}
            />
          );
        })}
      </SwipeableList>
    </Wrapper>
  );
};

export default CartItems;
